import ModalCommon from "./ModalCommon";

const FormModal = ({ title, isOpen, toggle, children, ...rest }) => {
  return (
    <ModalCommon
      title={title}
      isOpen={isOpen}
      toggle={toggle}
      backdrop={"static"}
      {...rest}
    >
      {children}
    </ModalCommon>
  );
};

export default FormModal;
